import {gql} from 'apollo-angular'
import {SYNDICATIONS_CREDIT_DETAILS_FRAGMENT} from "../../syndications-pipeline/graphql/getSyndications";


export var update_fund_details = gql`
  mutation updateFundInfo(
    $id: ID!
    $input: UpdateFundDetailInput!
    $fund_status_id: ID!
    $status_id: ID!
    $legal_entity_id: ID!
    $legal_name: String!
  ) {
    updateFundDetails(id: $id, input: $input) {
      name
      ein
      ic_code
      legal_name
      commitments_required
      close_date
    }
    updateFundStatuses(id: $fund_status_id, status_id: $status_id){
      id
      status {
        id
        name
      }
    }
    updateLegalName: updateFundLegalEntity(id: $legal_entity_id, name: $legal_name){
      id
      name
    }
  }
`;

export var update_fund_managing_member = gql`
  mutation updateManagingMember($id: ID!, $name: String!){
    updateFundLegalEntity(id: $id, name: $name){
      id
      name
    }
  }
`

export var update_budget_revenue_year = gql`
    mutation updateSyndicationsDetail($id: ID!, $budget_amt: Float, $syndications_budget_year: Int){
        updateSyndicationsDetail(id: $id, budget_amt: $budget_amt, syndications_budget_year: $syndications_budget_year){
          budget_amt
          id
          syndications_budget_year
        }
    }
`

export var update_participants = gql`
    mutation updateFundParticipants($id: ID!, $person_id: ID, $organization_id: ID, $role_id: ID){
      updateFundParticipant(id: $id, person_id: $person_id, organization_id: $organization_id, role_id: $role_id){
        id
        person {
          id
          name
        }
        organization {
          name
          sponsor {
            id
            name
          }
        }
        role {
          name
        }
      }
    }
`

export var update_investment_detail = gql`
    mutation updateOwnershipInterestDetail($id: ID!, $investment_class_id: ID, $amount: Float, $admission_date: Date, $exit_date: Date){
      updateOwnershipInterestDetail(id: $id, investment_class_id: $investment_class_id, amount: $amount, admission_date: $admission_date, exit_date: $exit_date){
        id
        amount
        investmentClass {
          id
          name
        }
        admission_date
        exit_date
      }
    }
`
export var update_fund_investor = gql`
    mutation updateFundInvestor($id: ID!, $is_repeat: Boolean, $is_confirmed: Boolean, $is_new: Boolean, $is_pending: Boolean, $notes: String){
      updateFundInvestor(id: $id, is_repeat: $is_repeat, is_confirmed: $is_confirmed, is_new: $is_new, is_pending: $is_pending, notes: $notes){
        id
        is_repeat
        is_pending
        notes
        ownershipInterest {
          id
          organization {
            id
            name
          }
          ownershipInterestDetail {
            id
            amount
            investmentClass {
              id
              name
            }
            admission_date
            exit_date
          }
        }
      }
    }
`

export var update_project_credit = gql`
    mutation updateProjectCredit(
      $outlet_input: UpdateProjectCreditOutletInput!,
    ){
      updateProjectCreditOutlet(input: $outlet_input){
        id
        ownership
        fundProjectState {
          name
        }
        admitted_date
        is_target
        is_target_exit
        load_percentage
        exit_date
        ut_irr
        revenue_year
        gross_equity
        estimated_gross_equity
        warehoused
        is_target_investor_approval
        investor_approval_date
        projected_warehouse_days
        fund {
          name
          id
          non_certificated_load
          certificated_load
        }
        certificatedOutlet {
          id
          non_certificated_load
          certificated_load
          organization {
            id
            name
          }
        }
        projectCredit {
          ...SyndicationsCreditFields
        }
      }

    }
    ${SYNDICATIONS_CREDIT_DETAILS_FRAGMENT}
`

export var add_fund_participant = gql`
    mutation addFundParticipant($fund_id: ID!, $person_id: ID, $organization_id: ID, $role_id: ID){
      addFundParticipant(fund_id: $fund_id, person_id: $person_id, organization_id: $organization_id, role_id: $role_id){
        id
        person {
          id
          name
        }
        organization {
          id
          name
          sponsor {
            id
            name
          }
        }
        role {
          name
        }
      }
    }
`

export var add_certificated_participant = gql`
    mutation addCertificatedParticipant($certificated_outlet_id: ID!, $person_id: ID, $organization_id: ID, $role_id:ID){
      addCertificatedParticipant(certificated_outlet_id: $certificated_outlet_id, person_id: $person_id, organization_id: $organization_id, role_id: $role_id){
        id
      }
    }
`

export var remove_participant = gql`
    mutation removeFundParticipant($id: ID!){
      removeFundParticipant(id:$id){
        id
      }
    }
`

export var create_fund_owned_entity = gql`
    mutation createFundOwnedEntity($name: String!, $fund_id: ID!){
      createFundOwnedEntity(name: $name, fund_id: $fund_id){
        id
        name
      }
    }
`
export var create_owned_entity_attribute = gql`
    mutation createOwnedEntityAttribute($owned_entity_id: ID!, $owned_entity_type_id: ID!){
      createFundOwnedEntityAttribute(owned_entity_id: $owned_entity_id, owned_entity_type_id: $owned_entity_type_id){
        id
        owned_entity_id
        ownedEntity{
          name
        }
      }
    }
`

export var create_new_budget_revenue_detail = gql`
    mutation createSyndicationsDetail($budget_amt: Float!, $fund_id: ID!, $syndications_budget_year: Int!){
      createSyndicationsDetail(budget_amt: $budget_amt, fund_id: $fund_id, syndications_budget_year: $syndications_budget_year){
        budget_amt
        id
        syndications_budget_year
      }
    }
`

export var create_investment_detail = gql`
    mutation createFundOwnershipInterestDetail(
      $ownership_interest_id: ID!,
      $amount: Float!,
      $investment_class_id: ID!,
      $admission_date: Date,
      $exit_date: Date
    ){
      createFundOwnershipInterestDetail(
        ownership_interest_id: $ownership_interest_id,
        investment_class_id: $investment_class_id,
        amount: $amount,
        admission_date: $admission_date,
        exit_date: $exit_date
      ){
        id
        amount
        investmentClass {
          id
          name
        }
        admission_date
        exit_date
      }
    }
`

export var create_fund_investor = gql`
    mutation createFundInvestor($ownership_interest_id: ID!, $is_pending: Boolean!, $is_repeat: Boolean!, $is_new: Boolean!, $is_confirmed: Boolean!, $notes: String){
      createFundInvestor(ownership_interest_id: $ownership_interest_id, is_repeat: $is_repeat, is_pending: $is_pending, is_new: $is_new, is_confirmed: $is_confirmed, notes: $notes){
        id
        is_repeat
        is_pending
        notes
        ownershipInterest {
          id
          organization {
            id
            name
          }
          ownershipInterestDetail {
            id
            amount
            investmentClass {
              id
              name
            }
            admission_date
            exit_date
          }
        }
      }
    }
`
export var create_fund_ownership_interest = gql`
    mutation createOwnershipInterest($owned_entity_id: ID!, $owner_type_id:ID!, $organization_id: ID!){
      createInvestorOwnershipInterest(owned_entity_id: $owned_entity_id, owner_type_id: $owner_type_id, organization_id: $organization_id ){
        id
      }
    }
`

export var create_project_credit = gql`
    mutation createProjectCredit($input: CreateProjectCreditInput!){
      createProjectCredit(input: $input){
        id
      }
    }
`

export var create_project_credit_outlet = gql`
  mutation createProjectCreditOutlet($input: CreateProjectCreditOutletInput!){
    createProjectCreditOutlet(input: $input){
      id
      ownership
      fundProjectState {
        name
      }
      admitted_date
      is_target
      is_target_exit
      load_percentage
      exit_date
      ut_irr
      revenue_year
      gross_equity
      estimated_gross_equity
      warehoused
      is_target_investor_approval
      investor_approval_date
      projected_warehouse_days
      fund {
        name
        id
        non_certificated_load
        certificated_load
      }
      certificatedOutlet {
        id
        non_certificated_load
        certificated_load
        organization {
          id
          name
        }
      }
      projectCredit {
        ...SyndicationsCreditFields
      }
    }
  }
  ${SYNDICATIONS_CREDIT_DETAILS_FRAGMENT}
`

export var delete_fund_investor = gql`
    mutation deleteFundInvestor($fund_investor_id: ID!, $ownership_interest_id: ID!){
      deleteFundInvestor(id: $fund_investor_id){
        id
      }
      deleteOwnershipInterest(id: $ownership_interest_id){
        id
      }
    }
`

export var delete_fund_investment_detail = gql`
    mutation deleteOwnershipInterestDetail($id: ID!){
        deleteOwnershipInterestDetail(id: $id){
          id
        }
    }
`

export var delete_budget_revenue_detail = gql`
    mutation deleteSyndicationsDetail($id: ID!){
      deleteSyndicationsDetail(id: $id){
        id
      }
    }
`

export var delete_project_credit_outlet = gql`
    mutation deleteProjectCreditOutlet($id: ID!){
      deleteProjectCreditOutlet(id: $id){
        id
        projectCredit {
          taxCreditType {
            name
            level
          }
        }
        fundProjectState {
          name
        }
      }
    }
`
